import axios, { AxiosError } from "axios";
import { apiConfig } from "./config";
import type { ApiErrorResponse } from "./interface";

const apiClient = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: apiConfig.timeout,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiErrorResponse>) => {
    const apiMessage = error.response?.data?.message;

    return Promise.reject({
      status: error.response?.status,
      message: apiMessage ?? error.message ?? "Une erreur est survenue.",
      errors: error.response?.data?.errors,
      originalError: error,
    });
  }
);

export default apiClient;